import { render, staticRenderFns } from "./ChartOfAccount.vue?vue&type=template&id=4993c5c0&"
import script from "./ChartOfAccount.vue?vue&type=script&lang=js&"
export * from "./ChartOfAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports